import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Share2, Check, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { assetShareUrl, copyShareText } from '../lib/assetShare';
import { assetShareMessage } from '../lib/assetShareMessage';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const AssetShareButton = ({ assetId, asset }) => {
  const [busy, setBusy] = useState(false), [copied, setCopied] = useState(false), [manual, setManual] = useState('');
  const cached = useRef(null), revision = useRef(0);
  const dataVersion = JSON.stringify([asset?.codigo_npl, asset?.direccion, asset?.municipio]);
  useEffect(() => {
    revision.current += 1; cached.current = null; setManual(''); setCopied(false); setBusy(false);
    return () => { revision.current += 1; };
  }, [assetId, dataVersion]);
  const share = async () => {
    // El texto usa los datos visibles de la ficha; el enlace conserva su verificación de acceso.
    const current = revision.current;
    setBusy(true); setCopied(false); setManual('');
    try {
      let url = cached.current;
      if (url) {
        await axios.get(`${API}/asset-links/${url.split('/').pop()}`, { withCredentials: true });
      } else {
        const { data } = await axios.post(`${API}/assets/${encodeURIComponent(assetId)}/share-link`, {}, { withCredentials: true });
        url = assetShareUrl(data);
      }
      if (revision.current !== current) return;
      cached.current = url;
      const message = assetShareMessage(asset, url);
      try { await copyShareText(message); setCopied(true); toast.success('Mensaje copiado'); }
      catch (_) { setManual(message); toast.error('No se pudo acceder al portapapeles. Puedes copiar el mensaje seleccionado.'); }
    } catch (error) {
      cached.current = null;
      if (revision.current === current) toast.error(error.response?.data?.detail || 'No se pudo preparar el enlace para compartir.');
    } finally { if (revision.current === current) setBusy(false); }
  };
  return <>
    <span className="inline-flex items-center gap-2 shrink-0" data-testid="asset-share-controls">
      <button type="button" className="inline-flex h-8 items-center justify-center gap-2 px-2 rounded border border-slate-400/30 text-xs transition-colors hover:bg-slate-400/15 disabled:opacity-50" data-testid="asset-share-button" aria-label="Compartir activo: copiar mensaje" title={copied ? 'Mensaje copiado' : 'Compartir activo: copiar mensaje'} disabled={busy} onClick={share}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : copied ? <Check className="w-4 h-4" /> : <Share2 className="w-4 h-4" />}Compartir
      </button>
    </span>
    {manual && <label className="text-xs w-full min-w-0" data-testid="asset-share-manual-label">Mensaje para compartir<textarea autoFocus readOnly value={manual} rows={3} className="input-base w-full mt-1 resize-y" data-testid="asset-share-manual-text" onFocus={e => e.target.select()} /></label>}
  </>;
};